export const revendaDirectAdminEua = [
  {
    name: "Revenda DirectAdmin EUA SSD 1",
    audience: "Para começar a revender com DirectAdmin nos EUA.",
    price: "55,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Armazenamento", value: "15 GB SSD" },
      { label: "Tráfego", value: "800 GB" },
    ],
    features: ["Painel DirectAdmin + Softaculous", "Até 10 contas (domínios ilimitados)"],
  },
  {
    name: "Revenda DirectAdmin EUA SSD 2",
    audience: "Para revendedores com carteira de clientes em crescimento.",
    price: "83,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Armazenamento", value: "60 GB SSD" },
      { label: "Tráfego", value: "1.200 GB" },
    ],
    features: ["Painel DirectAdmin + Softaculous", "Até 100 contas (domínios ilimitados)"],
  },
  {
    name: "Revenda DirectAdmin EUA SSD 3",
    audience: "Para operações maiores com tráfego ilimitado.",
    price: "139,90",
    unit: "/mês",
    highlighted: true,
    badge: "Mais escolhido",
    specs: [
      { label: "Armazenamento", value: "200 GB SSD" },
      { label: "Tráfego", value: "Ilimitado" },
    ],
    features: ["Painel DirectAdmin + Softaculous", "Contas ilimitadas (domínios ilimitados)"],
  },
  {
    name: "Revenda DirectAdmin EUA SSD 4",
    audience: "Para quem precisa de mais espaço e contas sem limite.",
    price: "279,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Armazenamento", value: "400 GB SSD" },
      { label: "Tráfego", value: "Ilimitado" },
    ],
    features: ["Painel DirectAdmin + Softaculous", "Contas ilimitadas (domínios ilimitados)"],
  },
];

export const revendaCpanelEua = [
  {
    name: "Revenda CPanel EUA 1",
    audience: "Primeiros passos revendendo com cPanel nos EUA.",
    price: "55,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Armazenamento", value: "10 GB SSD" },
      { label: "Tráfego", value: "500 GB" },
    ],
    features: ["Painel cPanel/WHM + Softaculous", "Até 5 contas (domínios ilimitados)"],
  },
  {
    name: "Revenda CPanel EUA 2",
    audience: "Para revendedores com demanda moderada de contas.",
    price: "83,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Armazenamento", value: "50 GB SSD" },
      { label: "Tráfego", value: "1.000 GB" },
    ],
    features: ["Painel cPanel/WHM + Softaculous", "Até 10 contas (domínios ilimitados)"],
  },
  {
    name: "Revenda CPanel EUA 3",
    audience: "Para operações em crescimento que precisam de mais espaço.",
    price: "139,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Armazenamento", value: "200 GB SSD" },
      { label: "Tráfego", value: "Ilimitado" },
    ],
    features: ["Painel cPanel/WHM + Softaculous", "Até 30 contas (domínios ilimitados)"],
  },
  {
    name: "Revenda CPanel EUA 4",
    audience: "Para quem gerencia uma carteira maior de clientes.",
    price: "279,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Armazenamento", value: "400 GB SSD" },
      { label: "Tráfego", value: "Ilimitado" },
    ],
    features: ["Painel cPanel/WHM + Softaculous", "Até 50 contas (domínios ilimitados)"],
  },
  {
    name: "Revenda CPanel EUA 5",
    audience: "Para revendedores que atendem muitos clientes ao mesmo tempo.",
    price: "489,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Armazenamento", value: "500 GB SSD" },
      { label: "Tráfego", value: "Ilimitado" },
    ],
    features: ["Painel cPanel/WHM + Softaculous", "Até 100 contas (domínios ilimitados)"],
  },
  {
    name: "Revenda CPanel EUA 6",
    audience: "Para operações de grande porte que exigem espaço dedicado.",
    price: "1.259,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Armazenamento", value: "1.000 GB SSD" },
      { label: "Tráfego", value: "Ilimitado" },
    ],
    features: ["Painel cPanel/WHM + Softaculous", "Até 100 contas (domínios ilimitados)"],
  },
];

export const revendaDirectAdminBr = [
  {
    name: "Revenda DirectAdmin BR SSD 1",
    audience: "Para começar a revender com DirectAdmin no Brasil.",
    price: "55,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Armazenamento", value: "10 GB SSD" },
      { label: "Tráfego", value: "120 GB" },
    ],
    features: ["Painel DirectAdmin + Softaculous", "Até 10 contas (domínios ilimitados)"],
  },
  {
    name: "Revenda DirectAdmin BR SSD 2",
    audience: "Para revendedores com carteira de clientes em crescimento.",
    price: "83,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Armazenamento", value: "60 GB SSD" },
      { label: "Tráfego", value: "250 GB" },
    ],
    features: ["Painel DirectAdmin + Softaculous", "Até 100 contas (domínios ilimitados)"],
  },
  {
    name: "Revenda DirectAdmin BR SSD 3",
    audience: "Para operações maiores com mais tráfego e espaço.",
    price: "139,90",
    unit: "/mês",
    highlighted: true,
    badge: "Mais escolhido",
    specs: [
      { label: "Armazenamento", value: "200 GB SSD" },
      { label: "Tráfego", value: "400 GB" },
    ],
    features: ["Painel DirectAdmin + Softaculous", "Contas ilimitadas (domínios ilimitados)"],
  },
  {
    name: "Revenda DirectAdmin BR SSD 4",
    audience: "Para quem precisa de bastante espaço e contas sem limite.",
    price: "279,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Armazenamento", value: "400 GB SSD" },
      { label: "Tráfego", value: "1.000 GB" },
    ],
    features: ["Painel DirectAdmin + Softaculous", "Contas ilimitadas (domínios ilimitados)"],
  },
];

export const revendaCpanelBr = [
  {
    name: "Revenda CPanel BR 1",
    audience: "Primeiros passos revendendo com cPanel no Brasil.",
    price: "55,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Armazenamento", value: "10 GB SSD" },
      { label: "Tráfego", value: "100 GB" },
    ],
    features: ["Painel cPanel/WHM + Softaculous", "Até 5 contas (domínios ilimitados)"],
  },
  {
    name: "Revenda CPanel BR 2",
    audience: "Para revendedores com demanda moderada de contas.",
    price: "83,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Armazenamento", value: "50 GB SSD" },
      { label: "Tráfego", value: "250 GB" },
    ],
    features: ["Painel cPanel/WHM + Softaculous", "Até 10 contas (domínios ilimitados)"],
  },
  {
    name: "Revenda CPanel BR 3",
    audience: "Para operações em crescimento que precisam de mais espaço.",
    price: "139,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Armazenamento", value: "200 GB SSD" },
      { label: "Tráfego", value: "400 GB" },
    ],
    features: ["Painel cPanel/WHM + Softaculous", "Até 30 contas (domínios ilimitados)"],
  },
  {
    name: "Revenda CPanel BR 4",
    audience: "Para quem gerencia uma carteira maior de clientes no Brasil.",
    price: "279,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Armazenamento", value: "400 GB SSD" },
      { label: "Tráfego", value: "1.000 GB" },
    ],
    features: ["Painel cPanel/WHM + Softaculous", "Até 50 contas (domínios ilimitados)"],
  },
];

export const revendaGroups = [
  {
    key: "eua",
    title: "Revenda — EUA",
    description:
      "Servidores nos Estados Unidos com painel DirectAdmin ou cPanel/WHM + Softaculous. Do revendedor iniciante à operação com muitos clientes.",
    icon: "ri-flag-line",
    tone: "primary",
    subGroups: [
      {
        key: "da-eua",
        label: "DirectAdmin",
        icon: "ri-window-2-line",
        columns: 4,
        plans: revendaDirectAdminEua,
      },
      {
        key: "cpanel-eua",
        label: "cPanel",
        icon: "ri-dashboard-3-line",
        columns: 3,
        plans: revendaCpanelEua,
      },
    ],
  },
  {
    key: "br",
    title: "Revenda — Brasil",
    description:
      "Servidores no Brasil com painel DirectAdmin ou cPanel/WHM + Softaculous, para atender os seus clientes com mais desempenho.",
    icon: "ri-map-pin-2-line",
    tone: "accent",
    subGroups: [
      {
        key: "da-br",
        label: "DirectAdmin",
        icon: "ri-window-2-line",
        columns: 4,
        plans: revendaDirectAdminBr,
      },
      {
        key: "cpanel-br",
        label: "cPanel",
        icon: "ri-dashboard-3-line",
        columns: 4,
        plans: revendaCpanelBr,
      },
    ],
  },
];

export const revendaPlans = [
  ...revendaDirectAdminEua,
  ...revendaCpanelEua,
  ...revendaDirectAdminBr,
  ...revendaCpanelBr,
];

export const revendaBenefits = [
  {
    icon: "ri-price-tag-3-line",
    title: "Preços e margens de revenda",
    description: "Condições especiais de parceiro para você revender com margem atrativa.",
  },
  {
    icon: "ri-dashboard-3-line",
    title: "Painel de clientes",
    description: "Gerencie as contas dos seus clientes em um só lugar, de forma simples.",
  },
  {
    icon: "ri-award-line",
    title: "A sua marca",
    description: "Atenda os seus clientes com a identidade da sua empresa.",
  },
  {
    icon: "ri-map-pin-2-line",
    title: "Infraestrutura no Brasil",
    description: "Servidores no Brasil para mais desempenho e proximidade do seu público.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Suporte ao parceiro",
    description: "Uma equipe ao seu lado para ajudar a resolver e a evoluir.",
  },
  {
    icon: "ri-line-chart-line",
    title: "Estrutura para crescer",
    description: "Amplie os recursos conforme a sua base de clientes aumenta.",
  },
];

export const partnerConditions = [
  "Preços exclusivos de parceiro para revenda",
  "Contas de hospedagem para os seus clientes",
  "E-mail profissional no domínio dos clientes",
  "Painel para gerenciar contas e clientes",
  "Atendimento com a marca da sua empresa",
  "Suporte técnico dedicado ao revendedor",
  "Estrutura no Brasil com boa performance",
  "Possibilidade de ampliar recursos conforme a demanda",
];

export const partnerSteps = [
  {
    icon: "ri-chat-3-line",
    title: "Fale com um especialista",
    description: "Conte como você pretende revender e qual é o seu objetivo com o programa.",
  },
  {
    icon: "ri-price-tag-3-line",
    title: "Escolha o plano",
    description: "Indicamos o plano de revenda mais adequado ao seu momento e à sua demanda.",
  },
  {
    icon: "ri-settings-3-line",
    title: "Configuramos a sua estrutura",
    description: "Montamos o espaço, o painel e ajustamos tudo para você começar a atender.",
  },
  {
    icon: "ri-rocket-line",
    title: "Comece a atender",
    description: "Você passa a cadastrar clientes e revender com o apoio da nossa equipe.",
  },
];

export const revendaFaqs = [
  {
    question: "O que é a revenda de hospedagem?",
    answer:
      "É a possibilidade de você oferecer hospedagem para os seus próprios clientes utilizando a infraestrutura da NXHOST, com preços especiais de parceiro e um painel para gerenciar as contas.",
  },
  {
    question: "Preciso de conhecimento técnico para começar?",
    answer:
      "Não é obrigatório. Você conta com o suporte da nossa equipe e pode começar de forma simples. Se quiser se aprofundar, ajudamos na configuração do seu ambiente.",
  },
  {
    question: "Posso atender os meus clientes com a minha própria marca?",
    answer:
      "Sim. A proposta do programa de revenda é que você atenda os seus clientes com a identidade da sua empresa, mantendo o relacionamento e a marca com você.",
  },
  {
    question: "Quantos clientes consigo atender?",
    answer:
      "Depende do plano escolhido e da sua demanda. Os recursos podem ser ampliados conforme a sua base de clientes cresce.",
  },
  {
    question: "Vocês oferecem suporte ao revendedor?",
    answer:
      "Sim. Além do suporte voltado aos seus clientes, você conta com atendimento dedicado ao parceiro para ajudar na operação do dia a dia.",
  },
  {
    question: "Como funciona a migração dos meus clientes?",
    answer:
      "A nossa equipe orienta e acompanha a migração dos sites e e-mails, buscando manter tudo funcionando durante a transição para a NXHOST.",
  },
];